module.exports = __webpack_public_path__ + "img/icon-discover.e47fc0fb.svg";